import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';

import { AssessmentPageComponent } from 'src/app/components/assessment-page/assessment-page.component';
import { QUESTION_PAGE_UI } from 'src/app/constants/ui-strings';
import { StateManagementService } from 'src/app/services/state-management.service';
import { TestService } from 'src/app/services/test.service';

export const testDeactivateGuard: CanDeactivateFn<AssessmentPageComponent> = () => {
    const confirmationService = inject(ConfirmationService);
    const stateManagementService = inject(StateManagementService);
    const testService = inject(TestService);

    if (stateManagementService.isSubmitTestRouteAllowed) {
      return true;
    }
    const confirmationResult$ = new Subject<boolean>();

    // Get fullscreen enforcement setting from test data
    const isFullScreenEnforced = testService.testData()?.proctor_settings?.enforce_fullscreen ?? false;

    confirmationService.confirm({
        message: QUESTION_PAGE_UI.exit_test_message,
        header: QUESTION_PAGE_UI.exit_test_header,
        icon: 'pi pi-window-maximize',
        accept: () => {
            confirmationResult$.next(true);
            confirmationResult$.complete();
        },
        reject: () => {
            // Use the service method for consistent cross-browser support
            testService.goFullscreen(isFullScreenEnforced).catch(() => {
              // Error already handled in service
            });
            confirmationResult$.next(false);
            confirmationResult$.complete();
        },
        closeOnEscape: false
    });

    return confirmationResult$.asObservable();
};
